import { useTranslation } from 'react-i18next';

interface PasswordToggleButtonProps {
  visible: boolean;
  onToggle: () => void;
  className?: string;
  iconClassName?: string;
  disabled?: boolean;
  tabIndex?: number;
}

// Show/hide eye button shared by every password field (LabeledFormField,
// PasswordInput) so the icon swap and aria-label live in one place.
export const PasswordToggleButton = ({
  visible,
  onToggle,
  className,
  iconClassName,
  disabled,
  tabIndex,
}: PasswordToggleButtonProps) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className={className}
      onClick={onToggle}
      aria-label={visible ? t('FIELD.HIDE_PASSWORD') : t('FIELD.SHOW_PASSWORD')}
      aria-pressed={visible}
      disabled={disabled}
      tabIndex={tabIndex}
    >
      <span className={['material-icons', iconClassName].filter(Boolean).join(' ')} aria-hidden="true">
        {visible ? 'visibility_off' : 'visibility'}
      </span>
    </button>
  );
};
